import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import quickAccessLinkServices from '@src/services/quickAccessLinks.services';

export const getAllQuickAccessLinks = createAsyncThunk(
  'getAllQuickAccessLinks',
  async (_, { rejectWithValue }) => {
    try {
      const result = await quickAccessLinkServices.getQuickAccessLinksGetList();
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getAllQuickAccessLinksWithParam = createAsyncThunk(
  'admin/getAllQuickAccessLinks',
  async ({ body, pageNumber, pageSize }, { rejectWithValue }) => {
    try {
      const result = await quickAccessLinkServices.getQuickAccessLinksGetListWithParam({ body, pageNumber, pageSize });
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const addQuickAccessLinks = createAsyncThunk(
  'admin/addQuickAccessLinks',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await quickAccessLinkServices.addQuickAccessLinks(data);
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const deleteQuickAccessLinks = createAsyncThunk(
  'admin/deleteQuickAccessLinks',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await quickAccessLinkServices.deleteQuickAccessLinks({ id });
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const updateQuickAccessLinks = createAsyncThunk(
  'admin/updateQuickAccessLinks',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await quickAccessLinkServices.updateQuickAccessLinks(data);
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  quickAccessLinks: [],
  tableProperty: {
    currentPage: 1,
    pageSize: 10,
    totalCount: 1,
    totalPages: 1,
  },
  response: {},
};

export const quickAccessLinkSlice = createSlice({
  name: 'quickAccessLink',
  initialState,
  reducers: {
    resetResponse: (state) => {
      state.response = {}
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAllQuickAccessLinks.fulfilled, (state, action) => {
      state.quickAccessLinks = action?.payload?.data?.items;
    });
    builder.addCase(getAllQuickAccessLinksWithParam.fulfilled, (state, action) => {
      state.quickAccessLinks = action?.payload?.data?.items;
      state.tableProperty = action?.payload?.data?.pagedProperty;
    });
    builder.addCase(getAllQuickAccessLinksWithParam.rejected, (state, action) => {
      state.quickAccessLinks = [];
      state.tableProperty = {
        currentPage: 1,
        page: 1,
        pageSize: 10,
        totalCount: 0,
      };
    });
    builder.addCase(addQuickAccessLinks.fulfilled, (state, action) => {
        state.response = action.payload;
      },
    );
    builder.addCase(addQuickAccessLinks.rejected, (state, action) => {
        state.response = action.payload;
      },
    );
    builder.addCase(deleteQuickAccessLinks.fulfilled, (state, action) => {
        state.response = action.payload;
      },
    );
    builder.addCase(deleteQuickAccessLinks.rejected, (state, action) => {
        state.response = action.payload;
      },
    );
    builder.addCase(updateQuickAccessLinks.fulfilled, (state, action) => {
        state.response = action.payload;
      },
    );
    builder.addCase(updateQuickAccessLinks.rejected, (state, action) => {
        state.response = action.payload;
      },
    );
  },
});

export const { resetResponse } = quickAccessLinkSlice.actions;
